import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

// Locale-aware drop-in replacements for next/link + next/navigation.
// These automatically add the /th prefix and preserve the active locale.
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
